import { Button, Box, Typography } from '@mui/material';
import React from 'react'
import Data from './Data';
import Login from './Login';
import { useAuth } from './utils/Auth';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import './BodyContent.css';
import Grid from '@mui/material/Grid';

export default function Header() {

    const auth = useAuth();
    const { enqueueSnackbar } = useSnackbar();

    const logoutUser = () => {
        let nonce = typeof Window.nonce !== 'undefined' ? Window.nonce : auth.nonce;
        axios.get("https://inlinetracking.com/wp-json/inline-tracking/v1/route/logout", { headers: { "X-WP-Nonce": nonce } })
            .then(response => response.data)
            .then(data => auth.logout())
            .catch(error => enqueueSnackbar(error.response.data.message, { variant: 'error', autoHideDuration: 6000 }));
    };

    return (
        <div className='main-body'>
            {auth.isLoggedIn ?
                <div className='Body'>
                    <div style={{ textAlign: 'end' }}>
                        <Box sx={{ margin: '10px', display: '-webkit-inline-box', alignItems: "baseline", }}>
                            <Grid container justifyContent="flex-end" alignItems="center">
                                <Grid item >
                                    <Typography sx={{ mr: 2, fontSize: '1rem' }} variant="h6">
                                        {' Logged in as ' + auth.displayName}
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Button size="medium" variant='contained' onClick={logoutUser} >
                                        Log Out
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </div>
                    <Data />
                </div>
                :
                <Login />
            }
        </div>
    )
}